import Link from 'next/link'
import Button from 'components/Button'
import { faRepeat } from '@fortawesome/pro-regular-svg-icons'
import {
  CollectiveProposalQueryResult,
  CollectiveProposalStatus,
  useResetExecutionMutation,
  CollectiveProposalExecutionStatus
} from 'graphql/generated'

type TProposal = NonNullable<
  CollectiveProposalQueryResult['collectiveProposal']
>
interface IProps {
  proposal: TProposal
}

function BatchNotice({ proposal }: IProps) {
  return (
    <div className="border-t border-t-gray-200 pt-[20px] mt-[20px]">
      <p className="text-center font-normal text-sm text-gray-900">
        {`This proposal was batched, and failed to execute on the blockchain.`}
      </p>

      {!!proposal.batchProposal && (
        <>
          {` In order to retry executing it, `}
          <Link className="text-blue" href={proposal.batchProposal.publicUrl}>
            {`head over to the batch proposal page`}
          </Link>
          {`.`}
        </>
      )}
    </div>
  )
}

function ProposalExecutionReset({ proposal }: IProps) {
  const [resetExecution, { loading }] = useResetExecutionMutation({
    variables: {
      proposalId: proposal.id
    }
  })

  const failedToExecute =
    proposal.status === CollectiveProposalStatus.EXECUTED &&
    proposal.execution?.status === CollectiveProposalExecutionStatus.FAILED
  if (!failedToExecute) {
    return null
  } else if (proposal.isPartOfBatch) {
    return <BatchNotice proposal={proposal} />
  }

  return (
    <div className="border-t border-t-gray-200 pt-[20px] mt-[20px]">
      <p className="text-center font-normal text-sm text-gray-900">
        {`This proposal failed to execute on the blockchain. You may retry executing it by clicking on the button below. Signators will need to re-sign before you can attempt to re-execute.`}
      </p>

      <div className="flex flex-row justify-center pt-[15px]">
        <Button
          label={`Reset Execution`}
          icon={faRepeat}
          color={'blue'}
          onClick={() => resetExecution()}
          disabled={loading}
        />
      </div>
    </div>
  )
}

export default ProposalExecutionReset
